import React from 'react';
import "./ParticipatingPlan.css";
import mainImg from "../Investment/Images/partcipating-plan.png";
import pnbImg from "../Investment/Images/pnbmetlife-logo.png";
import GoogleRating from './UtilityComponents/GoogleRating';

const ParticipatingPlan = () => {
    return (
        <>
            <div className="containerParticipating">
                <h4>Engage in Financial Journey with Our <span>Participating Plans</span>!</h4>
                <small className="PPTxt">Discover a Variety of Investment Options Secured by Insurance</small>

                <div id="imgContainer">
                    <img src={mainImg} alt="Participating Plan" id='mainImg' />
                    <div className="bgDiv" id='pnbDiv-PP' ><img src={pnbImg} alt="PNB medlife" id='pnbImg' /></div>
                    
                    <div id="googleRating-PP">
                        <GoogleRating className="googleRating" />
                    </div>
                </div>


            </div>
        </>
    )
}

export default ParticipatingPlan;
